import { render, staticRenderFns } from "./LiveDemoPage.vue?vue&type=template&id=2305902d&scoped=true&"
import script from "./LiveDemoPage.vue?vue&type=script&lang=js&"
export * from "./LiveDemoPage.vue?vue&type=script&lang=js&"
import style0 from "./LiveDemoPage.vue?vue&type=style&index=0&id=2305902d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2305902d",
  null
  
)

export default component.exports